// FAQ content, shared by the /faq page and the prerender script (which injects
// FAQPage JSON-LD into the static HTML for non-JS crawlers). Plain data — no JSX.
export const faqs = [
  {
    q: 'What is My Football Game?',
    a: 'My Football Game is a free online football manager game you play in your browser. You create your own club, build a squad, set tactics, sign players on the transfer market and compete in live simulated matches against friends and managers from around the world.'
  },
  {
    q: 'Is My Football Game free to play?',
    a: 'Yes. My Football Game is completely free to play. You can optionally buy gold coins to unlock booster packs and premium items faster, but everything in the game can be enjoyed without spending money.'
  },
  {
    q: 'Do I need to download or install anything?',
    a: 'No download is needed. My Football Game runs entirely in your web browser on desktop, tablet and mobile. Just register at myfootballgame.com and start managing your club in under a minute.'
  },
  {
    q: 'How do matches work?',
    a: 'When you challenge another manager, the match is scheduled and then simulated by our match engine minute by minute. You can watch the events unfold live - goals, cards, injuries and substitutions - and your tactics, lineup and player ratings all influence the result.'
  },
  {
    q: 'How do I sign new players?',
    a: 'Open the transfer market to browse players listed by other managers. You can buy players with coins, and sell your own players to raise funds. Smart trading is one of the fastest ways to strengthen your squad.'
  },
  {
    q: 'What is the difference between coins and gold coins?',
    a: 'Coins are the free currency you earn by playing matches, claiming your daily bonus and selling players. Gold coins are the premium currency used for exclusive booster packs and items in the store.'
  },
  {
    q: 'How can I earn free coins?',
    a: 'Log in every day to claim your daily bonus, win matches, and sell players you no longer need on the transfer market. Consistent daily play is the best way to grow your budget.'
  },
  {
    q: 'What are booster packs and stat boosts?',
    a: 'Booster packs from the store contain rewards such as coins, player boosts or items. Stat boosts temporarily improve your players\' attributes - activate them before an important match to gain an edge.'
  },
  {
    q: 'How do tactics affect my matches?',
    a: 'Your formation, mentality, pressing style and set-piece takers all feed directly into the match simulation. A tactic that suits your squad can beat a stronger team on paper, so experiment and adapt to each opponent.'
  },
  {
    q: 'Can I play against my friends?',
    a: 'Yes. Add friends in the game, then send them a direct challenge to play a friendly or competitive match. You can also join random challenges to face managers worldwide.'
  },
  {
    q: 'What happens when a player gets a red card or injured?',
    a: 'Players who receive a red card are suspended and unavailable for upcoming matches, so squad depth matters. Rotate your lineup and keep reliable backups for every position.'
  },
  {
    q: 'How do the leaderboards work?',
    a: 'Global leaderboards rank coaches by wins and score, and players by goals, assists and ratings. Every competitive match you play affects your position - climb the rankings to prove you are the best manager.'
  }
];

export default faqs;
